// frontend/src/components/Layout/Sidebar.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard,
  FileText,
  Settings,
  Mic,
  Users,
  LogOut,
  BookOpen,
  Play,
  Archive,
  X,
  Key
} from 'lucide-react';

const Sidebar = ({ onClose }) => {
  const { user, logoutUser, isAdmin } = useAuth();

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
      isActive
        ? 'bg-brand-dark text-white'
        : 'text-gray-600 hover:bg-brand-light hover:text-brand-dark'
    }`;

  const handleNavClick = () => {
    if (onClose) onClose();
  };

  return (
    <div className="w-64 bg-white h-screen flex flex-col border-r border-gray-200">
      {/* Logo */}
      <div className="p-6 border-b border-gray-200 flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-brand-dark">RN Insight Studio</h1>
          <p className="text-xs text-gray-500 mt-1">Content Automation Tool</p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="lg:hidden p-1 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={20} />
          </button>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        <NavLink to="/" end className={linkClass} onClick={handleNavClick}>
          <LayoutDashboard size={20} />
          <span>Dashboard</span>
        </NavLink>

        <NavLink to="/content" className={linkClass} onClick={handleNavClick}>
          <FileText size={20} />
          <span>Content Library</span>
        </NavLink>

        <NavLink to="/archive" className={linkClass} onClick={handleNavClick}>
          <Archive size={20} />
          <span>Archive</span>
        </NavLink>

        <NavLink to="/sources" className={linkClass} onClick={handleNavClick}>
          <BookOpen size={20} />
          <span>Sources</span>
        </NavLink>

        {isAdmin() && (
          <>
            <div className="pt-4 pb-2">
              <p className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                Admin
              </p>
            </div>

            <NavLink to="/topics" className={linkClass} onClick={handleNavClick}>
              <Play size={20} />
              <span>Topics</span>
            </NavLink>

            <NavLink to="/brand-voice" className={linkClass} onClick={handleNavClick}>
              <Mic size={20} />
              <span>Brand Voice</span>
            </NavLink>

            <NavLink to="/settings" className={linkClass} onClick={handleNavClick}>
              <Settings size={20} />
              <span>Settings</span>
            </NavLink>

            <NavLink to="/users" className={linkClass} onClick={handleNavClick}>
              <Users size={20} />
              <span>Users</span>
            </NavLink>

            <NavLink to="/api-keys" className={linkClass} onClick={handleNavClick}>
              <Key size={20} />
              <span>API Keys</span>
            </NavLink>
          </>
        )}
      </nav>

      {/* User Info */}
      <div className="p-4 border-t border-gray-200">
        <div className="flex items-center justify-between">
          <div className="min-w-0">
            <p className="text-sm font-medium text-gray-700 truncate">{user?.name}</p>
            <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
          </div>
          <button
            onClick={logoutUser}
            className="p-2 text-gray-400 hover:text-red-500 transition-colors flex-shrink-0"
            title="Logout"
          >
            <LogOut size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
